import React from 'react';
import { directRequire } from 'js/backbone/portlets';
import { componentService } from 'js/services/component.service';

class LoginWrapper extends React.Component {
    componentDidMount() {
        const [LoginView] = directRequire(['portlets_login_login_view']);

        this.view = new LoginView({ el: this.el });
        this.view.render();
    }

    componentWillUnmount() {
        this.view && this.view.close();
    }

    render() {
        return (
            <div
                ref={el => this.el = el}
                className={this.props.className}
            />
        );
    }
}

export const Login = (props) => <LoginWrapper {...props} />;

componentService.registerWebContentComponents({ Login });
